<template>
  <v-container fluid class="pt-3">
    <OrderTable :shop="shop" :showStat="true"></OrderTable>
  </v-container>
</template>
<script>
import Service from "../../services";
import OrderTable from "../../components/table/OrderTable";

export default {
  components: {
    OrderTable
  },
  data() {
    return {
      shop: null
    };
  },
  created() {}
};
</script>
